export default {"src":"/_next/static/media/Rbilogo.a1b1fe49.svg","height":49,"width":49};